"use strict";

const dataLayerModule = (function () {
    // Constants
    const EVENTS = {
        SELECT_ITEM: "select_item",
        VIEW_ITEM_LIST: "view_item_list"
    };

    const SOURCES = {
        ALTERNATIVE_DATE_SEARCH: "alternative_date_search",
        ALTERNATIVE_DATE_ITINERARY: "alternative_date_itinerary",
        PACKAGE_UPSELL_ITINERARY: "package_upsell_itinerary"
    };

    const ITEM_LIST = {
        ALTERNATIVE_DATE_NAME: "Alt Dates Modal",
        PACKAGE_UPSELL_NAME: "package_upsell_modal",
        ID: 0
    };

    // Public Methods
    const addSelectItemToDataLayerForAltDates = (cruiseId, packageRotationId, isSearchModal) => {
        const source = isSearchModal ? SOURCES.ALTERNATIVE_DATE_SEARCH : SOURCES.ALTERNATIVE_DATE_ITINERARY;
        _addSelectItem(cruiseId, packageRotationId, source, ITEM_LIST.ALTERNATIVE_DATE_NAME);
    };

    const addViewItemListToDataLayerForAltDates = (altListLinks, currentCruiseId) => {
        const isSearchModal = altListLinks[0]?.dataset.isSearchModal === 'true';
        const source = isSearchModal ? SOURCES.ALTERNATIVE_DATE_SEARCH : SOURCES.ALTERNATIVE_DATE_ITINERARY;
        _addViewItemList(altListLinks, source, ITEM_LIST.ALTERNATIVE_DATE_NAME, 'altDatesCount', currentCruiseId);
    };

    const addSelectItemToDataLayerForPackageUpsell = (cruiseId, packageRotationId) => {
        _addSelectItem(cruiseId, packageRotationId, SOURCES.PACKAGE_UPSELL_ITINERARY, ITEM_LIST.PACKAGE_UPSELL_NAME);
    };

    const addViewItemListToDataLayerForPackageUpsell = (packageUpsellItems, currentCruiseId) => {
        _addViewItemList(packageUpsellItems, SOURCES.PACKAGE_UPSELL_ITINERARY, ITEM_LIST.PACKAGE_UPSELL_NAME, 'packagesCount', currentCruiseId);
    };

    // Private Methods
    const _addSelectItem = (cruiseId, packageRotationId, source, itemListName) => {
        const selectedCruiseItem = [{
            item_id: cruiseId,
            is_recommended: false,
            is_boosted: window.boostedCruiseIds && window.boostedCruiseIds.includes(parseInt(cruiseId)),
            item_list_index: 0,
            package_sailing_id_strict: packageRotationId,
            click_source: source
        }];

        _pushToDataLayer({
            "event": EVENTS.SELECT_ITEM,
            "item_list_name": itemListName,
            "item_list_id": ITEM_LIST.ID,
            "selected_item": selectedCruiseItem
        });
    };

    const _addViewItemList = (items, source, itemListName, countDataset, currentCruiseId) => {
        const viewedCruiseList = [];

        items.forEach(link => {
            const cruiseId = link.dataset.cruiseId;
            const packageId = link.dataset.packageId;
            const count = link.dataset[countDataset];

            viewedCruiseList.push({
                item_id: cruiseId,
                is_recommended: false,
                is_boosted: window.boostedCruiseIds && window.boostedCruiseIds.includes(cruiseId),
                item_list_index: 0,
                package_sailing_id_strict: packageId,
                number_of_alternatives: count,
                view_source: source
            });
        });

        if (viewedCruiseList.length > 0) {
            // Ensure currentCruiseId is first in the list
            if (currentCruiseId) {
                const currentIndex = viewedCruiseList.findIndex(item => item.item_id === currentCruiseId);
                if (currentIndex > 0) {
                    const currentItem = viewedCruiseList.splice(currentIndex, 1)[0];
                    viewedCruiseList.unshift(currentItem);
                }
            }

            _pushToDataLayer({
                "event": EVENTS.VIEW_ITEM_LIST,
                "item_list_name": itemListName,
                "item_list_id": ITEM_LIST.ID,
                "items": viewedCruiseList
            });
        }
    };

    const _pushToDataLayer = (data) => {
        const dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push(data);
    };

    // Public API
    return {
        addSelectItemToDataLayerForAltDates,
        addViewItemListToDataLayerForAltDates,
        addSelectItemToDataLayerForPackageUpsell,
        addViewItemListToDataLayerForPackageUpsell
    };
})();

export default dataLayerModule;